




























import { Component, Vue } from 'vue-property-decorator';
import ProductGroupNew from '@/components/ProductGroup/ProductGroupNew.vue';

@Component({
  components: {
    ProductGroupNew,
  },
})
export default class ProductGroupNewButton extends Vue {
  private showDialog = false;
}
